import { calculateResults } from "./scoring";
import type { CalculatedResultRow } from "./types";
import { useData } from "./useData";

export interface ResultsState {
  results: CalculatedResultRow[];
  error?: unknown;
  loading: boolean;
}

export function useResults(index = 0): ResultsState {
  const { rows, matchups, loading, error } = useData();

  if (!matchups) {
    return { results: [], loading, error };
  }

  return {
    ...calculateResults(rows ?? [], matchups, index),
    loading,
    error,
  };
}
